import React from "react";
import EditorialHeader from "../compponents/EditorialHeader";
import EditorialFooter from "../compponents/EditorialFooter";
import useScrollReveal from "../hooks/useScrollReveal";
import { Link } from "react-router-dom";
import { ArrowUpRight, ArrowDown, Sparkles, Compass } from "lucide-react";
import { useTranslation } from "react-i18next";
import "./About.css";

const About = () => {
  const { t } = useTranslation();
  const page = useScrollReveal();

  return (
    <div className="about-page" ref={page}>
      <a className="about-skip" href="#about-main">{t("about.design.skip")}</a>
      <EditorialHeader />

      <main id="about-main">
        <section className="about-hero about-wrap" aria-labelledby="about-title">
          <div className="about-hero-copy">
            <p className="about-eyebrow"><span />{t("about.design.eyebrow")}</p>
            <h1 id="about-title">{t("about.introTitle")}<span className="about-title-dot">.</span></h1>
            <p className="about-hero-lead">{t("about.design.lead")}</p>
            <p className="about-body">{t("about.introSubtitle", { returnObjects: true })[0]}</p>
            <Link className="about-button" to="/contact">{t("about.introButton")}<ArrowUpRight size={20} aria-hidden="true" /></Link>
            <a className="about-scroll" href="#about-approach"><span><ArrowDown size={16} aria-hidden="true" /></span>{t("about.design.discover")}</a>
          </div>
          <div className="about-portrait-wrap">
            <div className="about-orbit" aria-hidden="true" />
            <figure className="about-portrait">
              <img src={`${process.env.PUBLIC_URL}/valeria_photo.png`} alt={t("about.design.portraitAlt")} width="1145" height="1374" fetchpriority="high" />
              <figcaption><span>VALERIA</span><span>{t("about.design.portraitCaption")}</span></figcaption>
            </figure>
            <div className="about-portrait-note"><Sparkles size={22} strokeWidth={1} aria-hidden="true" /><span>{t("about.design.note")}</span></div>
          </div>
        </section>

        <section id="about-approach" className="about-approach about-wrap" aria-labelledby="approach-title" data-reveal>
          <div className="about-section-heading"><p className="about-eyebrow">01 / {t("about.design.approachLabel")}</p><h2 id="approach-title">{t("about.design.approachTitle")}</h2></div>
          <div className="about-practices">
            {[["potential", Compass], ["energy", Sparkles]].map(([key, Icon], index) => (
              <article className="about-practice" key={key}>
                <div className="about-practice-top"><Icon size={30} strokeWidth={1.2} aria-hidden="true" /><span>0{index + 1}</span></div>
                <h3>{t(`about.design.${key}Title`)}</h3><p>{t(`about.design.${key}Description`)}</p>
                <Link className="about-text-link" to="/services">{t("about.design.explore")}<ArrowUpRight size={18} aria-hidden="true" /></Link>
              </article>
            ))}
          </div>
        </section>

        <section className="about-mission" aria-labelledby="mission-title" data-reveal>
          <div className="about-wrap about-mission-inner"><p className="about-eyebrow">02 / {t("about.design.missionLabel")}</p><h2 id="mission-title">{t("about.design.missionTitle")}</h2><p>{t("about.introSubtitle", { returnObjects: true })[3]}</p><span className="about-signature">Valeria</span></div>
          <div className="about-mission-rings" aria-hidden="true" />
        </section>

        <section className="about-connect about-wrap" aria-labelledby="connect-title" data-reveal>
          <div><p className="about-eyebrow">{t("about.design.nextStep")}</p><h2 id="connect-title">{t("about.design.connectTitle")}</h2><p>{t("about.design.connectDescription")}</p></div>
          <Link className="about-button" to="/contact">{t("about.introButton")}<ArrowUpRight size={20} aria-hidden="true" /></Link>
        </section>
      </main>
      <EditorialFooter />
    </div>
  );
};
export default About;
